
import { GameState } from './types';
import { getScaledValue } from './utils';

export class Renderer {
  private ctx: CanvasRenderingContext2D;
  private canvasWidth: number;
  private canvasHeight: number;
  // Add cached objects to prevent recreating the same objects each frame
  private fontCache: Record<string, string> = {};
  private lastFrameTime: number = 0;
  
  constructor(ctx: CanvasRenderingContext2D, canvasWidth: number, canvasHeight: number) {
    this.ctx = ctx;
    this.canvasWidth = canvasWidth;
    this.canvasHeight = canvasHeight;
  }
  
  updateCanvasSize(width: number, height: number): void {
    this.canvasWidth = width;
    this.canvasHeight = height;
    // Clear font cache when resizing to force recalculation
    this.fontCache = {};
  }

  clearCanvas(): void {
    this.ctx.fillStyle = '#000';
    this.ctx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);
  }
  
  drawShip(state: GameState): void {
    const ship = state.ship;
    
    this.ctx.save();
    this.ctx.translate(ship.x, ship.y);
    this.ctx.rotate(ship.angle);
    this.ctx.strokeStyle = '#fff';
    this.ctx.lineWidth = 2;
    this.ctx.beginPath();
    this.ctx.moveTo(0, -ship.radius);
    this.ctx.lineTo(ship.radius, ship.radius);
    this.ctx.lineTo(0, ship.radius / 2);
    this.ctx.lineTo(-ship.radius, ship.radius);
    this.ctx.closePath();
    this.ctx.stroke();
    this.ctx.restore();
  }
  
  drawBullets(state: GameState): void {
    // Batch draw bullets for better performance
    this.ctx.fillStyle = '#fff';
    this.ctx.beginPath();
    
    state.bullets.forEach(bullet => {
      this.ctx.moveTo(bullet.x, bullet.y);
      this.ctx.arc(
        bullet.x, 
        bullet.y, 
        getScaledValue(2, this.canvasWidth, this.canvasHeight), 
        0, 
        Math.PI * 2
      );
    });
    
    this.ctx.fill();
  }

  drawAsteroids(state: GameState): void {
    this.ctx.strokeStyle = '#fff';
    this.ctx.lineWidth = 2;
    
    state.asteroids.forEach(asteroid => {
      this.ctx.beginPath();
      this.ctx.arc(asteroid.x, asteroid.y, asteroid.radius, 0, Math.PI * 2);
      this.ctx.stroke();
    });
  }
  
  getFontSize(size: number): string {
    const key = `${size}-${this.canvasWidth}-${this.canvasHeight}`;
    if (!this.fontCache[key]) {
      this.fontCache[key] = `${getScaledValue(size, this.canvasWidth, this.canvasHeight)}px Arial`;
    }
    return this.fontCache[key];
  }
  
  drawUI(state: GameState): void {
    // Draw score
    this.ctx.fillStyle = '#fff';
    this.ctx.font = this.getFontSize(20);
    this.ctx.textAlign = 'left';
    this.ctx.fillText(
      `Score: ${state.score}`, 
      getScaledValue(20, this.canvasWidth, this.canvasHeight), 
      getScaledValue(30, this.canvasWidth, this.canvasHeight)
    );
    
    // Draw breathing guidance
    this.ctx.textAlign = 'center';
    this.ctx.fillText(
      'Take deep breaths while playing', 
      this.canvasWidth/2, 
      getScaledValue(30, this.canvasWidth, this.canvasHeight)
    );
  }
}
